module.exports = __webpack_public_path__ + "img/upload-example.d72208c6.png";